import './navbar.scss';

const NavBar = (props) => {
    const { indexQuestion, activeStep, nbQuestions, routes } = props;
    const pourcentage = Math.round((Number(indexQuestion + 1) / Number(nbQuestions + 1)) * 100);
    const stepsToDisplay = routes.slice(0, 4);
    const activeRoute = stepsToDisplay.find((s) => s.step === activeStep);

    return (
        <>
            {/* RGAA 12.1 - Second navigation system (visually hidden breadcrumb for screen readers) */}
            <nav aria-label="Progression du formulaire" className="visually-hidden">
                <ol>
                    {stepsToDisplay.map((s, i) => (
                        <li key={i} aria-current={s.step === activeStep ? 'step' : undefined}>
                            {s.step < activeStep && `${s.title} (terminée)`}
                            {s.step === activeStep && `${s.title} (en cours)`}
                            {s.step > activeStep && `${s.title} (à venir)`}
                        </li>
                    ))}
                </ol>
            </nav>

            <nav aria-label="Étapes du formulaire">
                {/* RGAA 10.8 - Mobile: visually-hidden text indicating current step for screen readers */}
                <span className="visually-hidden">
                    Étape {stepsToDisplay.findIndex((s) => s.step === activeStep) + 1} sur {stepsToDisplay.length}
                    {activeRoute ? `: ${activeRoute.title}` : ''}
                </span>

                <div className={'nav stepper'}>
                    {stepsToDisplay.map((s, i) => (
                        <div
                            className={`step col ${s.step === activeStep ? 'active' : ''} ${
                                s.step < activeStep ? 'past d-none d-lg-block' : ''
                            } ${s.step > activeStep ? 'disabled d-none d-lg-block' : ''}`}
                            key={i}
                            aria-current={s.step === activeStep ? 'step' : undefined}
                        >
                            {s.step <= activeStep ? (
                                <p>
                                    {/* RGAA 3.1 - Bold on active step for non-color indicator */}
                                    <a href={s.path} className={s.step === activeStep ? 'fw-bold' : ''}>
                                        {s.title}
                                    </a>
                                </p>
                            ) : (
                                <p>{s.title}</p>
                            )}
                            {/* RGAA 3.3 - Progress bar uses primary-dark color for better contrast */}
                            <div className="progress" role="progressbar" aria-label={`Progression de l'étape ${s.title}`} aria-valuenow={s.step === activeStep ? pourcentage : s.step < activeStep ? 100 : 0} aria-valuemin={0} aria-valuemax={100}>
                                {s.step === activeStep && (
                                    <div
                                        className="progress-bar bg-primary-dark"
                                        style={{ width: pourcentage + '%' }}
                                    />
                                )}
                                {s.step > activeStep && (
                                    <div className="progress-bar bg-primary-dark" style={{ width: '0%' }} />
                                )}
                                {s.step < activeStep && (
                                    <div className="progress-bar bg-primary-dark" style={{ width: '100%' }} />
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </nav>
        </>
    );
};

export default NavBar;
